<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input placeholder="Procurar"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="buttons">
                    <router-link :to="'/interface/maintenance/' + equipmentId" class="button is-primary">
                        {{$t('MANUTENCAOLISTA.INCLUIR')}}
                    </router-link>
                </div>
            </div>
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input :placeholder="$t('MANUTENCAOLISTA.CODIGO')"
                                 v-model="id"
                                 type="number"
                                 icon-right="edit"
                                 icon-right-clickable
                                 @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('MANUTENCAOLISTA.PROXPAGINA')"
                 :aria-previous-label="$t('MANUTENCAOLISTA.PAGINAANTERIOR')"
                 :aria-page-label="$t('MANUTENCAOLISTA.PAGINA')"
                 :aria-current-label="$t('MANUTENCAOLISTA.PAGINAATUAL')">

            <template @click="abrirCadastro(props.row.id)">
                <b-table-column v-slot="props" field="id" :label="$t('MANUTENCAOLISTA.CODIGO')">
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column v-slot="props" field="NomeTecnico" :label="$t('MANUTENCAOLISTA.NOMETECNICO')">
                    {{ props.row.nomeTecnico }}
                </b-table-column>

                <b-table-column v-slot="props" field="DataAgendada" :label="$t('MANUTENCAOLISTA.DATAAGENDADA')">
                    {{ $moment(props.row.dataAgendada).format("DD/MM/YYYY HH:mm") }}
                </b-table-column>

                <b-table-column v-slot="props" field="Funcionario" :label="$t('MANUTENCAOLISTA.FUNCIONARIO')">
                    {{ props.row.funcionarioNome}}
                </b-table-column>

                <b-table-column v-slot="props" custom-key="actions" numeric>
                    <router-link :to="{ name: 'interfacemaintenance', params: { equipmentId: equipmentId, id: props.row.id }}" class="button is-small is-primary" :title="$t('MANUTENCAOLISTA.EDITAR')">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>

            </template>
        </b-table>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? "",
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null,
                equipmentId: this.$route.params.equipmentid ?? 0
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    this.$t('MANUTENCAOLISTA.INTERFACE'),
                    this.$t('MANUTENCAOLISTA.MANUTENCOES'),
                    this.equipmentId
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `equipmentId=${this.equipmentId}`,
                    `page=${this.page}`,
                    `perPage=${this.perPage}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/interface/ManutencoesEquipamento?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/interface/maintenance/${this.equipmentId}/${this.id}` })
            },
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>